export const APP_CONSTANTS = {
  API: {
    DEFAULT_TENANT_ID: "e1f006ec",
    API_KEY: process.env.REACT_APP_API_KEY || "", // WARNING: Avoid exposing this client-side directly
    BASE_URL: process.env.REACT_APP_SERVICE_ENDPOINT || "",
  },
  DEFAULTS: {
    CURRENCY: "USD",
  }
};
